/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconTallymark3 = createReactComponent("tallymark-3", "IconTallymark3", [
  ["path", { d: "M8 5l0 14", key: "svg-0" }],
  ["path", { d: "M12 5l0 14", key: "svg-1" }],
  ["path", { d: "M16 5l0 14", key: "svg-2" }]
]);

export { IconTallymark3 as default };
//# sourceMappingURL=IconTallymark3.js.map
